
import { Row, Rows } from "../../../interfaces";

import { CellStyle } from "xlsx-js-style";
import { withCellStyles } from "../../../utils";

import { BmTemplateInternals, BudgetModalTemplateCurrentState } from "../budget-helper-internal";
import { leftIntendNoBold, textBold } from "../../../excelStyles";
import { BmDataFillingType } from "../../../../models/budget-model/pojo/bm-enums";
import { BmItemValue } from "../../../../models/budget-model/pojo/bm-classes-values";
import { BudgetModelFormGroup } from "../../../../models/budget-model/pojo/bm-form";

export class OrganizationExpensesSection {
  constructor(
    private readonly budgetForm: BudgetModelFormGroup,
    private readonly helper: BmTemplateInternals,
  ) { }

  fillOrganizationExpensesRows(rows: Rows, current: BudgetModalTemplateCurrentState): void {
    this.prepareOrganizationExpensesMainRow(rows, current);
    this.prepareOrganizationExpensesInternal(rows, current);
  }

  private prepareOrganizationExpensesMainRow(newData: Rows, current: BudgetModalTemplateCurrentState): void {
    const organizationExpensesTotalRow: Row = [];
    organizationExpensesTotalRow.push(withCellStyles('Organization Expenses', textBold));
    const organizationExpensesTotal = this.budgetForm.controls.modelData.controls.organizationalExpenses.value.total;
    const organizationExpensesTotalUpdated = this.helper.setNullToDataAfterYearForBmItems(organizationExpensesTotal as BmItemValue[]);

    organizationExpensesTotalUpdated.forEach((value, index) => {
      // skip first column
      if (index === 0) {
        return;
      }
      this.helper.pushSumOrValueWIthOutZeroIndex(organizationExpensesTotalRow, index, value, current.rowIndex, true);
    });

    this.helper.pushYearsTotalCellBold(organizationExpensesTotalRow, current.rowIndex, current.yearsIndexArray);
    this.helper.prepareCellForTotalPcnt(organizationExpensesTotalRow, current, true);
    this.helper.setCellForTotalPcntOfCommitment(organizationExpensesTotalRow, current.rowIndex, current.indexOfTotalColumn, true);
    newData.push(organizationExpensesTotalRow);
    current.indexArrayForTotalExpenses.push(current.rowIndex);
    current.rowIndex++;
  }

  private prepareOrganizationExpensesInternal(newData: Rows, current: BudgetModalTemplateCurrentState): void {
    this.budgetForm.controls.modelData.controls.organizationalExpenses.value.groups.forEach((operatingGroup) => {
      const orgSubGroupRow: Row = [];
      orgSubGroupRow.push(withCellStyles(operatingGroup.name, leftIntendNoBold as CellStyle));
      const operatingGroupItemsUpdated = this.helper.setNullToDataAfterYearForBmItems(operatingGroup.items as BmItemValue[], false);
      if (operatingGroup.dataFillingType === BmDataFillingType.YEARLY) {
        const separatedArr = this.helper.separateArrByYear(operatingGroup.items);
        this.helper.buildOperatingSubGroupRowForAnnualPeriodType(separatedArr as BmItemValue[][], operatingGroup.standardValue, orgSubGroupRow, current.rowIndex);
      } else {
        operatingGroupItemsUpdated.forEach((operatingItem, orgItemIndex) => {
          const type = operatingGroup.dataFillingType;
          const countedValue = this.helper.defineTypeOfCountingExpenses(operatingGroup.standardValue, type);
          if (operatingItem) {
            operatingItem.itemValue = operatingItem.itemValue ?? countedValue;
          }
          this.helper.pushSumOrValueWithZeroIndex(orgSubGroupRow, orgItemIndex, operatingItem, current.rowIndex);
        });
      }

      this.helper.pushYearsTotalCellGray(orgSubGroupRow, current.rowIndex, current.yearsIndexArray);
      this.helper.prepareCellForTotalPcnt(orgSubGroupRow, current);
      this.helper.setCellForTotalPcntOfCommitment(orgSubGroupRow, current.rowIndex, current.indexOfTotalColumn, true);
      newData.push(orgSubGroupRow);
      current.rowIndex++;
    });
  }
}
